import { Injectable } from '@angular/core';
import { ColumnState } from 'ag-grid-community';

@Injectable({
  providedIn: 'root',
})
export class AgGridPreferenceStore {
  private preferences: { [key: string]: ColumnState[] | null } = {};
  private gridId: { [key: string]: number | null } = {};

  getPreference(key: string): ColumnState[] | null {
    return this.preferences[key];
  }

  getGridId(key: string): number | null {
    return this.gridId[key];
  }

  setPreference(key: string, preference: ColumnState[]): void {
    this.preferences[key] = preference;
  }

  setGridId(key: string, gridId: number): void {
    this.gridId[key] = gridId;
  }
}
